import Header from './components/Header';

new Header();
